export enum InfrastructuresRoutesEnum {
  DesktopChangeInfrastructure = '/home/desktop/infrastructures/:id/edit',
}
